// import { useSuspenseQuery } from "@tanstack/react-query";
// import { todosQueryOptions } from "../api/queries";
import EncounterPreview from "../components/encounter-preview";
import HomeStats from "../components/home-stats";
// import Notifications from "../components/notifications";
import UpcomingPreview from "../components/upcoming-preview";
// import Notifications from "../components/notifications";


export function QuickActionsPage() {
  // const todosQuery = useSuspenseQuery(todosQueryOptions(apiProgram));

  return (
    <section
      role="main"
      aria-label="Quick Actions Overview"
      className="w-full max-w-[1440px] mx-auto flex flex-col px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 gap-6 md:gap-8 lg:gap-12 py-4 md:py-6"
    >
      <HomeStats />
      
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 w-full">
        <div className="lg:col-span-7 order-1 w-full">
          <EncounterPreview />
          {/* <div className="hidden lg:block mt-20">
          <Notifications />
          </div> */}
        </div>
        
        <div className="lg:col-span-5 order-2 w-full">
          <UpcomingPreview />
        </div>
        
        {/* <div className="lg:col-span-7 lg:hidden order-3 w-full">
          <Notifications />
        </div> */}
      </div>
    </section>
  );
}